import React, {useEffect} from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import RoutesConfig from "./RoutesConfig";
import NavBar from "./components/NavBar";
const environment = 'production';
const targetURL = environment === 'development' ? 'http://localhost:3000' : 'https://bixbite.ai';
const sendCurrentUrl = () => {
  window.parent.postMessage({ url: window.location.href }, targetURL);
};

const App = () => {
  let hoverHandler, removeHoverHandler, clickHandler;
  const location = useLocation();
    useEffect(() => {
        sendCurrentUrl();
        sendCurrentUrl();
        // Scroll to top on route change
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [location]); 

    const sendCurrentProperties = () => {
        const elements = document.body.querySelectorAll('*');
        const properties = {};
        elements.forEach((element, index) => {
            const elementId = element.id || `element-${index}`;
            if (!element.id) element.id = elementId;
            const componentSource = element.getAttribute('data-component');
            const componentSourcePath = element.getAttribute('path');
            if (componentSource) {
                properties[elementId] = {
                    component: componentSource,
                    path: componentSourcePath,
                    styles: element.style.cssText,
                    innerText: element.innerText || element.value || '',
                    tagName: element.tagName
                };
            }
        });
        window.parent.postMessage({ type: 'currentProperties', properties }, targetURL);
    };

    const enableElementSelection = () => {
        document.body.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            const element = event.target;
            const selectedElement = {
                id: element.id,
                tagName: element.tagName,
                innerText: element.innerText,
                styles: element.style.cssText,
                component: element.getAttribute('data-component') || 'Unknown',
                componentPath: element.getAttribute('path') || 'Unknown',
            };
            window.parent.postMessage({ type: 'selectedElement', selectedElement }, targetURL);
        });
    };

    const enableInspectMode = () => {
        document.body.style.cursor = 'pointer';

        hoverHandler = (event) => {
            event.target.style.outline = '1px solid #00796b';
        };

        removeHoverHandler = (event) => {
            event.target.style.outline = '';
        };

        clickHandler = (event) => {
            event.preventDefault();
            event.stopPropagation();
            event.target.style.outline = '';
            const element = event.target;
            const selectedElement = {
                id: element.id,
                tagName: element.tagName,
                innerText: element.innerText,
                styles: element.style.cssText,
                component: element.getAttribute('data-component') || 'Unknown',
                componentPath: element.getAttribute('path') || 'Unknown',
            };
            window.parent.postMessage({ type: 'selectedElement', selectedElement }, targetURL);
            disableInspectMode();
        };

        document.body.addEventListener('mouseover', hoverHandler);
        document.body.addEventListener('mouseout', removeHoverHandler);
        document.body.addEventListener('click', clickHandler);

        // console.log('Inspect mode enabled');
    };

    const disableInspectMode = () => {
        document.body.style.cursor = '';

        if (hoverHandler) {
            document.body.removeEventListener('mouseover', hoverHandler);
        }
        if (removeHoverHandler) {
            document.body.removeEventListener('mouseout', removeHoverHandler);
        }
        if (clickHandler) {
            document.body.removeEventListener('click', clickHandler);
        }
        const elements = document.querySelectorAll('*');
        elements.forEach((el) => {
            el.style.outline = '';
        });
        // console.log('Inspect mode disabled');
    };

    window.addEventListener('message', (event) => {
        if (event.origin !== targetURL) return;
        if (event.data.type === 'requestProperties') {
            sendCurrentProperties();
        }
        if (event.data.type === 'enableElementSelection') {
        enableElementSelection();
        }
        if (event.data.type === 'enableInspectMode') {
            enableInspectMode();
        }
        if (event.data.type === 'disableInspectMode') {
            disableInspectMode();
        }
    });

    window.addEventListener("message", (event) => {
        if (event.data.request === "getTitle") {
            window.parent.postMessage({ title: document.title }, targetURL);
        }
    });

  return (
   <>
    <NavBar />
    <Routes>
      {RoutesConfig.map((route, index) => (
        <Route key={index} path={route.path} element={route.element} />
      ))}
    </Routes>
   </>
  );
};

export default App;
